import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as React from 'react';
import { getInputContainerStyles, Icon, tokens, Text } from '@hotjar/hotsauce';
import { forwardRef } from 'react';

type WidgetContainerProps = {
  iconComponent: React.ReactElement;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  text: string;
  hideDropdownCaret?: boolean;
};

export const samplingWidgetButtonStyles = css`
  ${getInputContainerStyles({
    isInvalid: false,
    isReadonly: false,
    isDisabled: false,
  })};
  border: none;
  display: flex;
  align-items: center;
  gap: ${tokens.spacer.x1};
  width: auto;
  height: ${tokens.spacer.x5};
  padding: 0 ${tokens.spacer.x1pt5};
  ${tokens.elevation(0)};

  &:hover {
    ${tokens.elevation(0)};
    background-color: ${tokens.color.bg_hover};
  }

  &:focus-within {
    ${tokens.focus()}
  }
`;

const StyledWidgetContainer = styled.button`
  ${samplingWidgetButtonStyles}
`;

/**
 * This component will replace the WidgetContainer once we move to the new navigation.
 */
export const WidgetContainer = forwardRef<HTMLButtonElement, WidgetContainerProps>(
  (
    { iconComponent, text, hideDropdownCaret, ...otherProps }: WidgetContainerProps,
    ref,
  ): JSX.Element => (
    <StyledWidgetContainer ref={ref} {...otherProps} data-testid="sampling-widget-button">
      {iconComponent}
      <Text>{text}</Text>
      {!hideDropdownCaret && <Icon icon="caret_down_alt" size="m" color="text_disabled" />}
    </StyledWidgetContainer>
  ),
);
